import { CapturedPayment } from '../Dashboard.types';
import styles from './ScheduledView.module.css';
import { NewOrderSummary } from '../../NewOrderSummary/NewOrderSummary';

export const ScheduledView = ({ plan }: { plan: CapturedPayment }) => {
    return (
        <div data-testid="approved-view">
            <div className={styles.capturedPaymentInfo}>
                Your payment schedule has not yet started and will start 30 days
                after {plan.payLink.seller_trading_name} have confirmed the
                order.
            </div>
            <div className={styles.orderSummaryContainer}>
                <NewOrderSummary
                    title="Your pending payment schedule"
                    orderAmount={plan.payLink.amount}
                    plan={plan}
                />
            </div>
        </div>
    );
};
